// Etapas por unidad scout
export const ETAPAS_POR_UNIDAD = {
  bandada: [
    { value: "pichon",        label: "Pichón"       },
    { value: "aprendiz",      label: "Aprendiz"     },
    { value: "viajera",       label: "Viajera"      },
    { value: "guia_de_vuelo", label: "Guía de Vuelo"},
  ],
  manada: [
    { value: "lobezno",  label: "Lobezno"  },
    { value: "saltador", label: "Saltador" },
    { value: "diestro",  label: "Diestro"  },
    { value: "cazador",  label: "Cazador"  },
  ],
  compania: [
    { value: "alba",        label: "Alba"        },
    { value: "amanecer",    label: "Amanecer"    },
    { value: "luz",         label: "Luz"         },
    { value: "resplandor",  label: "Resplandor"  },
  ],
  tropa: [
    { value: "cernicalo", label: "Cernícalo" },
    { value: "halcon",    label: "Halcón"    },
    { value: "aguila",    label: "Águila"    },
    { value: "condor",    label: "Cóndor"    },
  ],
  avanzada: [
    { value: "sendero", label: "Sendero" },
    { value: "cumbre",  label: "Cumbre"  },
  ],
  clan: [
    { value: "fuego",    label: "Fuego"    },
    { value: "antorcha", label: "Antorcha" },
  ],
}

// Colores de badge por etapa — compartido entre lista y modal
export const BADGE_ETAPA = {
  // Bandada
  pichon:        "badge-etapa-pichon",
  aprendiz:      "badge-etapa-aprendiz",
  viajera:       "badge-etapa-viajera",
  guia_de_vuelo: "badge-etapa-guia",
  // Manada
  lobezno:       "badge-etapa-manada-1",
  saltador:      "badge-etapa-manada-2",
  diestro:       "badge-etapa-manada-3",
  cazador:       "badge-etapa-manada-4",
  // Compañía
  alba:          "badge-etapa-comp-1",
  amanecer:      "badge-etapa-comp-2",
  luz:           "badge-etapa-comp-3",
  resplandor:    "badge-etapa-comp-4",
  // Tropa
  cernicalo:     "badge-etapa-tropa-1",
  halcon:        "badge-etapa-tropa-2",
  aguila:        "badge-etapa-tropa-3",
  condor:        "badge-etapa-tropa-4",
  // Avanzada
  sendero:       "badge-etapa-avanzada-1",
  cumbre:        "badge-etapa-avanzada-2",
  // Clan
  fuego:         "badge-etapa-clan-1",
  antorcha:      "badge-etapa-clan-2",
}